import { useTranslation } from "react-i18next";

import { botColorVar } from "@/entities/robot";
import { Button } from "@/shared/ui";

/**
 * Блок первого входа. Figma: `Choose Robot` (19:28) — 350×172, три чипа
 * с роботами и CTA.
 *
 * Чипы в макете подписаны Anchor / Range / Trend. Это витрина, а не список из
 * API: реальный каталог грузится на своём экране, а тянуть сюда `GET /robots`
 * ради трёх названий значило бы тратить лимит запросов (60/мин на IP) на
 * декорацию.
 */
const SHOWCASE = ["anchor", "range", "trend"] as const;

export function ChooseRobot({ onChoose }: { onChoose: () => void }) {
  const { t } = useTranslation();

  return (
    <section className="flex w-full flex-col gap-2.5 rounded-[20px] border border-border-subtle bg-background-elevated p-4">
      <h2 className="text-h3 font-semibold text-text-primary">{t("home.chooseRobot.title")}</h2>
      <p className="text-caption font-normal text-text-secondary">{t("home.chooseRobot.body")}</p>

      <ul className="flex flex-wrap gap-[7px]">
        {SHOWCASE.map((code) => (
          <li
            key={code}
            className="flex items-center gap-1.5 rounded-full bg-background-raised p-[9px] text-micro font-semibold text-neutral-label"
          >
            <span
              className="size-[7px] rounded-full"
              style={{ backgroundColor: botColorVar(code) }}
              aria-hidden="true"
            />
            {t(`robots.names.${code}`)}
          </li>
        ))}
      </ul>

      <Button size="cta" block onClick={onChoose}>
        {t("home.chooseRobot.cta")}
      </Button>
    </section>
  );
}
